input{padding:0 11px;border:1px solid #d9d9d9;height:32px}.tubeCharacteristics-submitted .tubeCharacteristics.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=tube-characteristics-add-edit.component-7HMTFLTD.css.map */
